import { Routes, Route, useSearchParams } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Designer from "./routes/Designer";
import FormAndViewer from "./routes/FormAndViewer";
import Templates from "./routes/Templates";
import Header from "./components/Header";
import PreviewPDF from "./routes/preview";

export default function App() {
  const [searchParams] = useSearchParams();
  const isEmbedded = searchParams.get("embed") === "true";

  return (
    <div className="min-h-screen flex flex-col">
      {!isEmbedded && <Header />}
      <Routes>
        <Route path={"/"} element={<Designer />} />
        <Route path={"/designer"} element={<Designer />} />
        <Route path="/templates" element={<Templates isEmbedded={isEmbedded} />} />
        <Route path="/preview-pdf" element={<PreviewPDF />} />
      </Routes>
      <ToastContainer />
    </div>
  );
}
